
import React, { useState, useEffect } from "react";
import { Copy, Gift, Users } from "lucide-react";
import { FaRegStar } from "react-icons/fa";

const ReferEarn = ({ userId }) => {
  const [copied, setCopied] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [referralCode, setReferralCode] = useState(""); // 👈 dynamic

  // fetch referralCode by userId
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const id = userId || localStorage.getItem("userId") || 6;
        const response = await fetch(
          `https://backend.maamaas.com/food/user/getprofile/${id}`
        );
        const data = await response.json();
        if (data.referralCode) {
          setReferralCode(data.referralCode); // set code from API
        }
      } catch (error) {
        console.error("Error fetching referral code:", error);
      }
    };

    fetchProfile();
  }, []);

  const contacts = [
    { id: 1, name: "John Doe", number: "+1234567890" },
    { id: 2, name: "Jane Smith", number: "+1987654321" },
    { id: 3, name: "Alice Brown", number: "+1122334455" },
  ];

  const handleSelect = (contact) => setSelectedContact(contact);

  const handleCopy = () => {
    if (!referralCode) return;
    navigator.clipboard.writeText(referralCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  useEffect(() => {
    document.body.style.overflow = showPopup ? "hidden" : "auto";
  }, [showPopup]);

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "2rem 1rem",
        backgroundColor: "#f9fafb",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Banner */}
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          background: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          borderRadius: "1rem",
          padding: "1.5rem",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <p
          style={{
            fontSize: "1.125rem",
            fontWeight: "500",
            color: "#7c3aed",
            textAlign: "center",
          }}
        >
          Invite your friends & earn exclusive rewards! 💰
        </p>
      </div>

      {/* Referral Code Box */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          backgroundColor: "#fff",
          padding: "1rem",
          borderRadius: "1rem",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          marginTop: "1.5rem",
          width: "100%",
          maxWidth: "400px",
          border: "1px solid #d1d5db",
        }}
      >
        <span
          style={{
            fontWeight: "bold",
            fontSize: "1.125rem",
            letterSpacing: "2px",
            wordBreak: "break-word",
            textAlign: "center",
          }}
        >
          {referralCode || "Loading..."}
        </span>
        <button
          onClick={handleCopy}
          disabled={!referralCode}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            padding: "0.5rem 1rem",
            borderRadius: "0.5rem",
            color: "#fff",
            backgroundColor: copied ? "#10b981" : "#2563eb",
            fontSize: "0.875rem",
            border: "none",
            cursor: referralCode ? "pointer" : "not-allowed",
            transition: "background-color 0.3s",
            justifyContent: "center",
          }}
        >
          {copied ? "✔️ Copied!" : (
            <>
              <Copy size={18} />
              Copy
            </>
          )}
        </button>
      </div>

      {/* Invite Button */}
      {/* <button
        style={{
          marginTop: "1rem",
          padding: "0.5rem 1.5rem",
          backgroundColor: "#7c3aed",
          color: "#fff",
          fontSize: "0.875rem",
          borderRadius: "0.5rem",
          border: "none",
          cursor: "pointer",
          transition: "background-color 0.3s",
        }}
        onClick={() => setShowPopup(true)}
      >
        🚀 Invite Friends
      </button> */}

      {/* How It Works */}
      <div
        style={{
          marginTop: "2.5rem",
          width: "100%",
          maxWidth: "400px",
        }}
      >
        <h2
          style={{
            fontSize: "1.5rem",
            fontWeight: "600",
            marginBottom: "1rem",
            textAlign: "center",
          }}
        >
          📌 How It Works
        </h2>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "1.25rem",
            borderRadius: "1rem",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          }}
        >
          {[
            { icon: <Gift size={24} color="#7c3aed" />, text: "Share your referral code with friends." },
            { icon: <Users size={24} color="#7c3aed" />, text: "They sign up using your code." },
            { icon: <FaRegStar size={24} color="#7c3aed" />, text: "Earn rewards when they make a purchase!" },
          ].map((item, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.75rem",
                marginBottom: "1rem",
              }}
            >
              {item.icon}
              <p style={{ fontSize: "1rem", fontWeight: "500" }}>{item.text}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Popup Modal */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 50,
            padding: "1rem",
          }}
          onClick={() => setShowPopup(false)}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "1rem",
              padding: "1.25rem",
              maxWidth: "400px",
              width: "100%",
              position: "relative",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              style={{
                position: "absolute",
                top: "0.5rem",
                right: "0.5rem",
                fontSize: "1.25rem",
                color: "#6b7280",
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
              onClick={() => setShowPopup(false)}
            >
              ✖
            </button>
            <h2
              style={{
                fontSize: "1.125rem",
                fontWeight: "700",
                textAlign: "center",
                marginBottom: "1rem",
              }}
            >
              📞 Select a Contact
            </h2>
            <ul style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              {contacts.map((contact) => (
                <li
                  key={contact.id}
                  style={{
                    padding: "0.5rem 1rem",
                    border: "1px solid #d1d5db",
                    borderRadius: "0.5rem",
                    cursor: "pointer",
                    fontSize: "1rem",
                    backgroundColor:
                      selectedContact?.id === contact.id ? "#7c3aed" : "#f3f4f6",
                    color: selectedContact?.id === contact.id ? "#fff" : "#111827",
                    transition: "background-color 0.3s",
                  }}
                  onClick={() => handleSelect(contact)}
                >
                  {contact.name} - {contact.number}
                </li>
              ))}
            </ul>
            {selectedContact && (
              <button
                style={{
                  width: "100%",
                  marginTop: "1rem",
                  padding: "0.5rem",
                  backgroundColor: "#16a34a",
                  color: "#fff",
                  border: "none",
                  borderRadius: "0.5rem",
                  fontSize: "1rem",
                  cursor: "pointer",
                  transition: "background-color 0.3s",
                }}
                onClick={() =>
                  alert(`Message sent to ${selectedContact.number}`)
                }
              >
                Send to {selectedContact.number}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReferEarn;
